export interface AppConfig {
    BaseUrl: string | undefined;
    ApiBaseUrl: string | undefined;
    UseV2: string | undefined;
    CurrentWorker: string | undefined;
    SessionTimeout: string | undefined;
    CommonRequestInterval: string | undefined;
    TokenRequestInterval: string | undefined;
    MaxErrorLength: string | undefined;
    AdalTenant: string | undefined;
    AdalClientId: string | undefined;
    AdalRedirectUri: string | undefined;
    AdalPostLogoutUri: string | undefined;
    AdalScope: string | undefined;
    KeycloakUrl: string | undefined;
    KeycloakRealm: string | undefined;
    KeycloakClientId: string | undefined;
}

export async function getConfig(): Promise<AppConfig> {
    const env = window._env_ ?? {};

    return {
        BaseUrl: env.REACT_APP_BASE_URL ?? import.meta.env.REACT_APP_BASE_URL,
        ApiBaseUrl: env.REACT_APP_API_BASE_URL ?? import.meta.env.REACT_APP_API_BASE_URL,
        UseV2: env.REACT_APP_USE_V2 ?? import.meta.env.REACT_APP_USE_V2,
        CurrentWorker: env.REACT_APP_CURRENT_WORKER ?? import.meta.env.REACT_APP_CURRENT_WORKER,
        SessionTimeout: env.REACT_APP_SESSION_TIMEOUT ?? import.meta.env.REACT_APP_SESSION_TIMEOUT,
        CommonRequestInterval: env.REACT_APP_COMMON_REQUEST_INTERVAL ?? import.meta.env.REACT_APP_COMMON_REQUEST_INTERVAL,
        TokenRequestInterval: env.REACT_APP_TOKEN_REQUEST_INTERVAL ?? import.meta.env.REACT_APP_TOKEN_REQUEST_INTERVAL,
        MaxErrorLength: env.REACT_APP_MAX_ERROR_LENGTH ?? import.meta.env.REACT_APP_MAX_ERROR_LENGTH,
        AdalTenant: env.REACT_APP_ADAL_TENANT ?? import.meta.env.REACT_APP_ADAL_TENANT,
        AdalClientId: env.REACT_APP_ADAL_CLIENT_ID ?? import.meta.env.REACT_APP_ADAL_CLIENT_ID,
        AdalRedirectUri: env.REACT_APP_ADAL_REDIRECT_URI ?? import.meta.env.REACT_APP_ADAL_REDIRECT_URI,
        AdalPostLogoutUri: env.REACT_APP_ADAL_POST_LOGOUT_REDIRECT_URI ?? import.meta.env.REACT_APP_ADAL_POST_LOGOUT_REDIRECT_URI,
        AdalScope: env.REACT_APP_ADAL_SCOPE ?? import.meta.env.REACT_APP_ADAL_SCOPE,
        KeycloakUrl: env.REACT_APP_KEYCLOAK_URL ?? import.meta.env.REACT_APP_KEYCLOAK_URL,
        KeycloakRealm: env.REACT_APP_KEYCLOAK_REALM ?? import.meta.env.REACT_APP_KEYCLOAK_REALM,
        KeycloakClientId: env.REACT_APP_KEYCLOAK_CLIENT_ID ?? import.meta.env.REACT_APP_KEYCLOAK_CLIENT_ID,
    };
}